<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="framework/html_behaviors/af-items-loader"></require>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="framework/html_behaviors/af-measure"></require>
  <require from="framework/html_behaviors/af-sort-column"></require>
  <require from="framework/html_behaviors/af-sort-context"></require>
  <require from="controls/as-table-skeleton"></require>
  <require from="controls/as-page-jumbo.html"></require>
  <require from="controls/as-form-widget.html"></require>
  <require from="components/filters/map-zones-list-filter"></require>
  <require from="components/locations/map-zone-panel"></require>

  <div class="sc-filter-container ml-2 mr-2">
    <form>
      <map-zones-list-filter model.bind="controller.queryMemory.filter"></map-zones-list-filter>
      <div class="btn-toolbar justify-content-between flex-wrap-reverse" role="toolbar">
        <div class="btn-group d-block" role="group">
          <button type="button" class="btn btn-link text-primary" af-mutex-click.call="controller.createNewMapZone()" title="Create new Zone"><i class="fas fa-plus mr-1"></i>Create new</button>
        </div>
        <div class="btn-group ml-auto" role="group">
          <button type="submit" class="btn btn-secondary" af-mutex-click.call="controller.search()">
            <i class="fas fa-search"></i> Search
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="ml-2 mr-2">
    <table class="table table-borderless table-hover sc-table-fixed sc-table-sticky sc-list-highlight" af-sort-context.bind="controller.queryMemory.sortInstruction">
      <thead>
        <tr>
          <th af-sort-column="Name">Name</th>
          <th width="40px"></th>
        </tr>
      </thead>
      <tbody if.bind="controller.loaded">
        <template repeat.for="mapZone of controller.mapZones">
          <tr class="locations-list-row__summary map-zone-row ${!mapZone.data.isActive ? 'sc-archived' : ''} ${$index % 2 ? 'sc-row-even' : ''} ${mapZone.isHighlighted ? 'sc-row-highlighted' : ''} sc-content-appear" mouseover.delegate="highlightMapZone(mapZone)" mouseout.delegate="unhighlightMapZone(mapZone)">
            <td title="${mapZone.data.name}" class="sc-selectable" click.delegate="showDetail(mapZone)">${mapZone.data.name}</td>
            <td>
              <button type="button" class="btn btn-sm text-danger" title="Archive" af-mutex-click.call="archiveMapZone(mapZone)" show.bind="!mapZone.isEdited && mapZone.data.isActive && mapZone.data.id">
                <i class="fas fa-trash"></i>
              </button>
              <button type="button" class="btn btn-sm text-success" title="Restore" af-mutex-click.call="restoreMapZone(mapZone)" show.bind="!mapZone.isEdited && !mapZone.data.isActive && mapZone.data.id">
                <i class="fas fa-trash-restore"></i>
              </button>
            </td>
          </tr>
          <tr show.bind="mapZone.isDetailed" class="locations-list-row__detail map-zone-row ${mapZone.isHighlighted ? 'sc-row-highlighted' : ''} sc-content-appear" mouseover.delegate="highlightMapZone(mapZone)" mouseout.delegate="unhighlightMapZone(mapZone)">
            <td colspan="2">
              <div if.bind="mapZone.isDetailed">
                <map-zone-panel model.bind="mapZone.data" map-zone-detail-model.bind="mapZone" map-zones-controller.bind="controller"></map-zone-panel>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
      <tbody as-element="as-table-skeleton" else></tbody>
    </table>
    <div class="sc-table-norows" if.bind="controller.loaded && controller.mapZones.length === 0">No zones</div>
    <af-items-loader items.bind="controller.mapZones" fetch.call="controller.fetchMapZones(skip, take)" batch-size.bind="controller.batchSize" template="templates/items-loader.html"></af-items-loader>
  </div>
</template>
